import { Avatar } from '@app/components'

export const PAYMENT_CARDS_DATA = [
  {
    icon: <Avatar />,
    title: 'Spend in 150+ currencies',
    description: 'One card to spend or withdraw money with the real exchange rate.',
  },
  {
    icon: <Avatar />,
    title: 'Withdraw from ATMs anywhere',
    description: 'Withdrawal fees apply if you go over your fee-free limit.',
  },
  {
    icon: <Avatar />,
    title: 'Auto-convert on the go',
    description: 'Spend in any currency and we\'ll take care of conversion with our low fees.',
  },
  {
    icon: <Avatar />,
    title: 'Get Instant notifications',
    description: 'See what you’ve spent and track in app at home, abroad and on the go.',
  },
]
